<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="menuLeft">
         
        </template>
        <template slot-scope="scope" slot="menu">
        
          <el-button  v-if="permission.offlinePayUser_edit" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
         
        </template>
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
        <el-button
          type="danger"
          size="small"
        
          plain
          v-if="permission.offlinePayUser_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
    <hr-dialog :title="formTitle" :allowFull="false" width="60%" :visible.sync="formVisible">
        <template slot="body">
          <userForm
          :model="formModel"
            @cancle="recordCancle"
            v-if="formVisible"
            @success="recordSuccess"
           :row="rowInfo"
          ></userForm>
        </template>
      </hr-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update, getUserDetail, removePermission, getDictList } from '@/api/v4ward/offlinepay/user';
import { mapGetters } from 'vuex';
import userForm from './userForm.vue';
export default {
  components:{userForm},
  data() {
    return {
      formTitle:'新增',
      formModel:'add',
      rowInfo:{},
      formVisible:false,
      form: {},
      query: {},
      userDetail:{},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        inline: true,
        tip: false,
        border: true,
       editBtn:false,
       addBtn:false,
        index: true,
        indexLabel: '序号',
        // viewBtn: true,
        columnBtn: false,
        selection: true,
        searchMenuSpan: 6,
        column: [
          {
            label: 'ID主键',
            prop: 'id',
            hide: true,
            addDisplay: false,
            viewDisplay: true,
            editDisplay: false,
          },
          {
            label: '用户姓名',
            prop: 'userName',
            search:true,
            hide: false,
            addDisplay: false,
            viewDisplay: true,
            editDisplay: false,
            searchSpan: 5,
          },
          {
            label: '公众号入口',
            prop: 'h5EntrancePowerValue',
          },
          {
            label: '手机号码',
            prop: 'phone',
            search:true,
            hide: false,
            addDisplay: false,
            viewDisplay: true,
            editDisplay: false,
            searchSpan: 5,
          },
          // {
          //   label: '所属角色',
          //   prop: 'roleName',
          //   hide: false,
          //   addDisplay: false,
          //   viewDisplay: true,
          //   editDisplay: false,
          // },
          // {
          //   label: '所属部门',
          //   prop: 'deptName',
          //   hide: false,
          //   addDisplay: false,
          //   viewDisplay: true,
          //   editDisplay: false,
          // },
          {
            label: '用户姓名',
            prop: 'userId',
            placeholder: '请选择用户',
            hide: true,
            addDisplay: true,
            viewDisplay: false,
            editDisplay: true,
            editDisabled: true,
            type: 'tree',
            slot: true,
            filterable: true,
            dicUrl: 'api/v4ward/user/userPhone-list',
            props: { label: 'namePhone', value: 'id' },
            rules: [{ required: true, message: '请选择用户!', trigger: 'change' }],
            span: 12,
            change: ({value,column}) => {
              if (value){
                getUserDetail({ userId:value}).then(({ data }) => {
                  let ent = document.querySelector('input[placeholder=" "]');
                  ent.value=data.roleName;
                  ent = document.querySelector('input[placeholder="  "]');
                  ent.value=data.deptName;
                });
              }
            },
          },
          {
            label: '费用类型',
            prop: 'feeTypes',
            hide: true,
            span: 12,
            type: 'select',
            editDisabled: false,
            // viewDisplay: true,
            placeholder: "   ",
            viewDisabled: true,
            dataType: 'number',
            multiple:true,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/v4ward/charge/user/getFeeTypes?code=offline_fee_type',
            rules: [{ required: true, message: '请选择费用类型！', trigger: 'change', },]
          },
          {
            label: '所属角色',
            placeholder: ' ',
            prop: 'roleName',
            dictValue:'',
            hide: false,
            span: 12,
            editDisabled: true,
            addDisabled: true,
            viewDisplay: true,
            viewDisabled: true
          },
          {
            label: '所属部门',
            placeholder: '  ',
            prop: 'deptName',
            hide: false,
            span: 12,
            editDisabled: true,
            addDisabled: true,
          },
          {
            label: '小区名称',
            prop: 'communityNames',
            
          },
          {
            label: '费用类型',
            prop: 'feeTypesName',
            hide: false,
            addDisplay: false,
            viewDisplay: true,
            editDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.offlinePayUser_add, false),
        viewBtn: this.vaildData(this.permission.offlinePayUser_view, false),
        delBtn: this.vaildData(this.permission.offlinePayUser_delete, false),
        editBtn: this.vaildData(this.permission.offlinePayUser_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    recordSuccess(){
      this.formVisible=false;
      this.onLoad()
    },
    recordCancle(){
      this.formVisible=false;
    },
    editRecord(row){
      this.formModel = 'edit'
      this.formTitle='编辑'
      this.formVisible=true;
      this.rowInfo= row
    },
    addRecord(){
      this.formModel = 'add'
      this.formTitle='新增'
      this.formVisible=true;
    },
    rowSave(row, loading, done) {
      let type = typeof row.feeTypes;
      if (type!='string'){
        row.feeTypes = '';
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择用户删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      if (['add'].includes(type)) {
        //查询出全部的面缴权限字典,用于解决默认全选
        getDictList({code: 'offline_fee_type'}).then(({ data }) =>{
          this.form.feeTypes = [];
          data.forEach((ele) => {
            this.form.feeTypes.push(ele.dictKey);
          });
          console.log(this.form.feeTypes)
        });
      }
      if (['edit'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          let ent = document.querySelector('input[placeholder=" "]');
          ent.value=data.roleName;
          ent = document.querySelector('input[placeholder="  "]');
          ent.value=data.deptName;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
